export default __webpack_public_path__ + "static/media/sand-clock.4e026b5f.svg";